import { FC } from 'react';
import {
  Card, CardContent, Typography, Box, Grid
} from '@mui/material';
import TextFieldReadOnly from '@/components/TextFieldReadOnly';
import { useTranslation } from 'react-i18next';
import { useContracts } from '../../hooks/useContracts';
import { ContractDisplayTypes } from '../../types/contracts';

interface ISupplyDetailsProps {
  type: ContractDisplayTypes
}

export const SupplyDetails: FC<ISupplyDetailsProps> = ({
  type
}) => {
  const { t } = useTranslation();
  const { currentContract: contract } = useContracts(type);

  return contract && <Card style={{marginBottom: 3}}>
    <CardContent>
      <Box pb={2}>
        <Typography variant="h5">
          {t('common:text.contract_cups_info')}
        </Typography>
      </Box>
      <Grid container>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_cups')}
          >
            {contract.cups.name}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_cups_address')}
          >
            {contract?.cups?.full_address}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_distri')}
          >
            {contract.dso.name}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_contract_distri')}
          >
            {contract?.dso_reference}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly label={t('common:text.contract_cups_info_breakdown_num')}>
            {contract.dso_phone && <a href={`tel:${contract.dso_phone}`}>{contract.dso_phone}</a>}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly label={t('common:text.contract_cups_info_distri_website')}>
            {contract.dso.website && <a href={`${contract.dso.website}`}>{contract.dso.website}</a>}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_access_tariff')}>{contract.tariff.name}</TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_cups_info_ref')}>{contract.cups.ref_catastral}</TextFieldReadOnly>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}